import React from "react";

const FilledLatestAnnouncementIcon = ({ cls }) => {
  return (
    <svg
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M7 5.99994H11.975C12.3388 5.97869 18.6775 5.53244 24.7137 0.469944C25.0052 0.225135 25.3605 0.0685947 25.7379 0.0187126C26.1153 -0.0311695 26.4991 0.0276782 26.8441 0.188343C27.1892 0.349008 27.4813 0.604816 27.6861 0.925718C27.8908 1.24662 27.9997 1.61929 28 1.99994V21.9999C27.9999 22.3807 27.8912 22.7535 27.6866 23.0746C27.4819 23.3957 27.1898 23.6517 26.8447 23.8125C26.4996 23.9734 26.1157 24.0323 25.7382 23.9825C25.3607 23.9326 25.0053 23.7761 24.7137 23.5312C19.9925 19.5712 15.0887 18.4362 13 18.1187V22.0837C13.0004 22.4133 12.9194 22.7378 12.7641 23.0285C12.6088 23.3192 12.3841 23.567 12.11 23.7499L10.735 24.6662C10.4692 24.8436 10.1648 24.9547 9.84728 24.9903C9.52974 25.0258 9.2083 24.9848 8.90987 24.8706C8.61145 24.7564 8.34473 24.5723 8.13206 24.3339C7.91938 24.0954 7.76694 23.8094 7.6875 23.4999L6.21625 17.9549C4.69533 17.7681 3.30353 17.0064 2.32631 15.8261C1.34908 14.6458 0.860485 13.1363 0.96073 11.6072C1.06097 10.0781 1.74246 8.64536 2.86542 7.60273C3.98837 6.5601 5.4677 5.98663 7 5.99994ZM9.625 22.9862V22.9999L11 22.0837V17.9999H8.3L9.625 22.9862ZM7 15.9999H11V7.99994H7C5.93913 7.99994 4.92172 8.42137 4.17157 9.17152C3.42143 9.92166 3 10.9391 3 11.9999C3 13.0608 3.42143 14.0782 4.17157 14.8284C4.92172 15.5785 5.93913 15.9999 7 15.9999Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FilledLatestAnnouncementIcon;
